import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=23db7e9a&scoped=true"
import script from "./Commission.vue?vue&type=script&lang=js"
export * from "./Commission.vue?vue&type=script&lang=js"
import style0 from "./Commission.vue?vue&type=style&index=0&id=23db7e9a&prod&scoped=true&lang=css"
import style1 from "./Commission.vue?vue&type=style&index=1&id=23db7e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db7e9a",
  null
  
)

export default component.exports